var ArticleTagCloud,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

ArticleTagCloud = (function() {
  function ArticleTagCloud(tag) {
    this.tag = tag;
    this.load = __bind(this.load, this);
    this.reload = __bind(this.reload, this);
    this.subscribe = __bind(this.subscribe, this);
    this.selected_ids = __bind(this.selected_ids, this);
    Observable(this, 'loaded', false);
    ObservableArray(this, 'subtags');
    ObservableArray(this, 'subscribers');
    this.tag.subscribe(this.load);
  }

  ArticleTagCloud.prototype.selected_ids = function() {
    var selected_tags;
    selected_tags = this.subtags.select(function(tag) {
      return tag.selected();
    });
    return ko.utils.arrayMap(selected_tags, function(tag) {
      return tag.id;
    });
  };

  ArticleTagCloud.prototype.subscribe = function(fn) {
    return this.subscribers.push(fn);
  };

  ArticleTagCloud.prototype.reload = function() {
    return this.load();
  };

  ArticleTagCloud.prototype.load = function() {
    if (this.tag() === null || this.tag() === void 0) {
      this.loaded(false);
      return this.subtags.removeAll();
    }
    return ArticleTag.subtags({
      tag_ids: this.selected_ids()
    }, (function(_this) {
      return function(subtags) {
        var selected_ids, subscriber, tag, _i, _j, _len, _len1, _ref;
        selected_ids = _this.selected_ids();
        _this.subtags.removeAll();
        for (_i = 0, _len = subtags.length; _i < _len; _i++) {
          tag = subtags[_i];
          tag = Tag(tag);
          if (selected_ids.indexOf(tag.id) >= 0) {
            tag.select();
          }
          tag.selected.subscribe(_this.reload);
          _this.subtags.push(tag);
        }
        _ref = _this.subscribers();
        for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
          subscriber = _ref[_j];
          subscriber();
        }
        return _this.loaded(true);
      };
    })(this));
  };

  return ArticleTagCloud;

})();

//# sourceMappingURL=tagcloud.js.map
